<template>
  <div :data-view-id="uniqueTitle">
  <!-- ride stays off, so slides do not advance on their own and no pause control is needed. Previous and Next are named by BootstrapVue Next. -->
  <b-carousel controls controls-prev-text="Previous" controls-next-text="Next">
    <b-carousel-slide v-for="(component, index) in this.items" :key="index"
        :caption="component.caption"
        :text="component.text"
        :img-src="component.imageSource"
      />
  </b-carousel>
  </div>
</template>

<script>

export default {
  props: {
    items: {
      type: Array,
      default: []
    },
    uniqueTitle: {
      type: String,
      default: ''
    }
  }
}
</script>
